export default function registerGlobalComponents(app) {
}